import type { CreateCollectionBody } from "service/collections";

/** Text fields of the Create New Collection form (the moodboard file is held separately). */
export interface CollectionFormState {
  name: string;
  description: string;
  /** Selected project ids in pick order; empty for none. */
  projectIds: string[];
}

export const emptyCollectionForm = (): CollectionFormState => ({
  name: "",
  description: "",
  projectIds: [],
});

/** Only the name is required. */
export const isCollectionFormValid = (form: CollectionFormState): boolean =>
  form.name.trim().length > 0;

/**
 * Maps the form to the create body: trims text and drops blank optional
 * fields, so an untouched form creates a standalone collection. Picked
 * projects go in `linkedProjectIds`, linked in the same transaction.
 */
export const toCreateCollectionBody = (
  form: CollectionFormState,
): CreateCollectionBody => {
  const description = form.description.trim();
  return {
    name: form.name.trim(),
    ...(description && { description }),
    ...(form.projectIds.length > 0 && { linkedProjectIds: form.projectIds }),
  };
};
